import Splide from '@splidejs/splide';

const carousel = document.querySelector('.js-HeroCarousel')

if(carousel) {
  new Splide( carousel, {
    type: 'fade',
    pauseOnHover: false,
    pauseOnFocus: false,
    autoplay: true,
    interval: 4000,
    arrows: false,
    rewind: true,
    pagination: false
  } ).mount();
}
